import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { connect } from 'react-redux';

import actions from '../../store/actions';

const enhance = connect(null, {
  setSelectedMassId: actions.setSelectedMassId,
});

const AddOfferingButton = ({ massId, setSelectedMassId }) => {
  const addMassOffering = () => {
    setSelectedMassId(massId);
  };

  return <Button onClick={addMassOffering}>Zamów intencję</Button>;
};

AddOfferingButton.propTypes = {
  massId: PropTypes.string,
  setSelectedMassId: PropTypes.func,
};

export default enhance(AddOfferingButton);
